import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	HostBinding
} from "@angular/core";

@Component({
    selector: "dodo-mat-image-button",
    templateUrl: "./dodo-mat-image-button.component.html",
    styleUrls: ["./dodo-mat-image-button.component.scss"],
    standalone: false
})
export class DodoMatImageButtonComponent implements OnInit {
	public imageSize = 24;

	@Input() imageUrl: string;
	@Input() size = 24;
	@Output() click = new EventEmitter();
	@HostBinding("style.transform") scale: string;
	@HostBinding("style.margin-left.px") leftMargin: number;

	public scaleFactor = 1;

	constructor() {}

	ngOnInit() {
		this.scaleFactor = this.size / this.imageSize;
		this.scale = `scale(${this.scaleFactor})`;
		this.leftMargin = (this.scaleFactor - 1) * 40;
	}
}
